import { Dialog, DialogTitle, DialogContent, Button, Box, Typography, IconButton } from "@mui/material";
import { useBuyMessagesAPI, useMessageOptionsAPI } from "@arelia-components/SubscriptionDetails/useSubscriptionDetailsAPI";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    onClose: () => void;
};

export default function PurchaseMessagesDialog({ onClose }: Props) {
    const { data: options = [], isLoading } = useMessageOptionsAPI();
    const { mutate: buyMessages } = useBuyMessagesAPI();

    return (
        <Dialog open={true} maxWidth="sm" onClose={onClose}>
            <DialogTitle>
                <Box sx={styles.header}>
                    Buy Additional Messages Block
                    <IconButton aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers sx={styles.dialogContent}>
                <SpinnerWrapper loading={isLoading}>
                    {options.map((option) => (
                        <Box key={option.name} sx={styles.optionBox}>
                            <Typography variant="h6">
                                +{option.messageCount.toLocaleString()} SMS Messages
                            </Typography>
                            <Typography variant="body1" sx={styles.optionCost}>
                                ${option.cost}
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => buyMessages(option)}
                            >
                                Buy {option.messageCount.toLocaleString()}
                            </Button>
                        </Box>
                    ))}
                </SpinnerWrapper>
            </DialogContent>
        </Dialog>
    );
}

const styles = {
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    dialogContent: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "20px",
        overflow: "unset"
    },
    optionBox: {
        flex: 1,
        width: "100%",
        padding: "16px",
        border: "2px solid #c7c8c9",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "10px"
    },
    optionCost: {
        marginBottom: "8px"
    }
};
